// extracted by mini-css-extract-plugin
export default {"button":"IconButton_button__9QMBU","tooltip":"IconButton_tooltip__MHE6d"};